import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { AxiosResponse } from "axios";
import moment from "moment";
import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import InputMask from "react-input-mask";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import { toast } from "react-toastify";
import InsuranceService from "../../../Services/InsuranceService/InsuranceService";
import UserManagementService from "../../../Services/UserManagement/UserManagementService";
import NoRecord from "../../../Shared/Common/NoRecord";
import PermissionComponent, {
  getPermissionDisplayName,
  PermissionObject,
} from "../../../Shared/Common/Permissions/PermissionComponent";
import { reactSelectStyle, styles } from "../../../Utils/Common";
import {
  calculateShippingPriceFromRules,
  formatMoney,
  getTotalItemsPrice,
  getTotalOrderQuantity,
  ShippingMethodRule,
} from "./shippingPriceUtils";
import {
  GetShippingMethodLookup,
  GetSupplyOrderShippingMethodRulesById,
} from "Services/SupplyManagement/PricingConfigurationService";
import useLang from "Shared/hooks/useLanguage";
import usePageFieldConfig from "Shared/hooks/usePageFieldConfig";
import { getValueFromSessionStorage } from "Utils/Common/CommonMethods";
import { parseAdditionConfig } from "Pages/SupplyManagement/ManageInventory/additionConfigUtils";

function ViewOrders() {
  const { t } = useLang();
  const navigate = useNavigate();
  const location = useLocation();

  const { id } = location.state || {};

  const ShippingMethod = usePageFieldConfig(
    Number(getValueFromSessionStorage("pageId")),
    "ShippingMethod"
  );
  const showShippingMethod = ShippingMethod?.isShow === true;

  const ShippingPriceConfig = usePageFieldConfig(
    Number(getValueFromSessionStorage("pageId")),
    "ShippingPrice"
  );
  const showShippingPrice = ShippingPriceConfig?.isShow === true;

  const TotalItemPriceConfig = usePageFieldConfig(
    Number(getValueFromSessionStorage("pageId")),
    "TotalItemPrice"
  );
  const showTotalItemPrice = TotalItemPriceConfig?.isShow === true;

  const ShippingCommentsConfig = usePageFieldConfig(
    Number(getValueFromSessionStorage("pageId")),
    "ShippingComments"
  );
  const showShippingComments = ShippingCommentsConfig?.isShow === true;

  const [show, setShow] = useState(false);
  const [show1, setShow1] = useState(false);
  const [dropdown, setDropdown] = useState([]);
  const [buttonsShow, setButtonsShow] = useState(false);
  const [supplyOrders, setSupplyOrders] = useState<any>({});
  const [dropdownStates, setDropdownStates] = useState([]);
  const [shippingMethodLookup, setShippingMethodLookup] = useState<
    Array<{ value: number | string; label: string }>
  >([]);
  const [shippingMethodRules, setShippingMethodRules] = useState<
    ShippingMethodRule[]
  >([]);
  const shippingCourier = [
    { value: "UPS", label: "UPS" },
    { value: "FedEx", label: "FedEx" },
  ];
  const [shippingNow, setShippingNow] = useState({
    courierName: "",
    trackingNumber: "",
  });

  const hasAnyStripeItem = (supplyOrders?.supplyOrderItems || []).some(
    (item: any) => {
      const { isStripeEnabled } = parseAdditionConfig(item?.additionConfig);
      return isStripeEnabled;
    }
  );

  const isPaymentRestricted = ["pending payment", "payment approved"].includes(
    supplyOrders?.paymentStatus?.toLowerCase?.() ?? ""
  );

  const isReadOnly =
    isPaymentRestricted || supplyOrders?.status?.toLowerCase() === "shipped";

  const permissions = useSelector(
    (state: any) =>
      state?.Reducer?.selectedTenantInfo?.infomationOfLoggedUser?.permissions ||
      []
  );

  const hasPermission = permissions.some(
    (permission: PermissionObject) =>
      permission.subject.replace(/\n/g, "").toLowerCase() ===
        "Manage Order".replace(/\n/g, "").toLowerCase() &&
      permission.moduleName.replace(/\n/g, "").toLowerCase() ===
        "Supply Management".replace(/\n/g, "").toLowerCase() &&
      permission.action.replace(/\n/g, "").toLowerCase() ===
        "HideShippingDetail".replace(/\n/g, "").toLowerCase()
  );

  const handleChangeShipping = (e: any, name?: string) => {
    if (name) {
      setShippingNow((prev) => ({
        ...prev,
        [name]: e.value,
      }));
    } else {
      setShippingNow({
        ...shippingNow,
        [e.target.name]: e.target.value,
      });
    }
  };

  const GetShippingInfoById = () => {
    InsuranceService.GetShippingInfoById(id)
      .then((res: AxiosResponse) => {
        setSupplyOrders(res?.data?.data);
        const obj = res?.data?.data;
        for (const [key, value] of Object.entries(obj)) {
          setValue(key, value);
        }
        setButtonsShow(true);
        if (obj?.shippingMethod) {
          loadShippingMethodRules(obj.shippingMethod, obj.supplyOrderItems);
        }
      })
      .catch((err: any) => {
        console.trace(err, "err");
      });
  };

  const loadFacilitiesLookUp = () => {
    UserManagementService.GetFacilitiesLookup()
      .then((res: AxiosResponse) => {
        setDropdown(res?.data);
      })
      .catch((err: any) => {
        console.trace(err, "err");
      });
  };

  const loadShippingMethodLookup = () => {
    GetShippingMethodLookup()
      .then((res: AxiosResponse) => {
        const payload = res?.data;
        const data = Array.isArray(payload)
          ? payload
          : Array.isArray(payload?.data)
            ? payload.data
            : [];
        setShippingMethodLookup(
          data.map((item: any) => ({
            value: item.value,
            label: item.label,
          }))
        );
      })
      .catch((err: any) => {
        console.trace(err, "err");
      });
  };
  // React hook form start
  const {
    register,
    handleSubmit,
    clearErrors,
    setValue,
    formState: { errors },
  } = useForm<any>({
    defaultValues: {
      supplyOrder: [supplyOrders.supplyOrderItems], // Initialize with one row
    },
  });

  const handleKeyPress = (e: any) => {
    const keyCode = e.charCode || e.keyCode;
    const allowedKeyCodes = [8, 9, 37, 38, 39, 40, 46]; // 8: backspace, 9: tab, 37: left arrow, 38: up arrow, 39: right arrow, 40: down arrow

    if ((keyCode < 48 || keyCode > 57) && !allowedKeyCodes.includes(keyCode)) {
      e.preventDefault();
    }
  };

  const handleEnterPress = (e: any) => {
    if (e.key === "Enter") {
      e.preventDefault();
    }
  };
  // React hook form end
  const reset = () => {
    navigate("/manage-order", {
      state: { shipped: supplyOrders.status.toLowerCase() },
    });
  };

  function formatDate(inputDate: any) {
    if (!inputDate) {
      return "";
    } else {
      const date = new Date(inputDate);
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const year = date.getFullYear();
      const formattedDate = `${month}-${day}-${year}`;
      return formattedDate;
    }
  }

  const applyShippingPrice = (
    rules: ShippingMethodRule[],
    items: any[] = supplyOrders?.supplyOrderItems
  ) => {
    if (!showShippingPrice) return;
    const totalQty = getTotalOrderQuantity(items);
    const price = calculateShippingPriceFromRules(rules, totalQty);
    setSupplyOrders((prev: any) => ({
      ...prev,
      shippingPrice: price ?? "",
    }));
    setValue("shippingPrice", price ?? "");
  };

  const loadShippingMethodRules = (
    shippingMethodId: number | string,
    items?: any[]
  ) => {
    if (!shippingMethodId) {
      setShippingMethodRules([]);
      if (showShippingPrice) {
        setSupplyOrders((prev: any) => ({ ...prev, shippingPrice: "" }));
        setValue("shippingPrice", "");
      }
      return;
    }

    GetSupplyOrderShippingMethodRulesById(Number(shippingMethodId))
      .then((res: AxiosResponse) => {
        const data = res?.data?.data || [];
        const rules = Array.isArray(data) ? data : [];
        setShippingMethodRules(rules);
        applyShippingPrice(rules, items ?? supplyOrders?.supplyOrderItems);
      })
      .catch((err: any) => {
        console.trace(err, "err");
        setShippingMethodRules([]);
        if (showShippingPrice) {
          setSupplyOrders((prev: any) => ({ ...prev, shippingPrice: "" }));
          setValue("shippingPrice", "");
        }
      });
  };

  const handleChange = (e: any, name: string) => {
    setSupplyOrders((prev: any) => ({
      ...prev,
      [name]: e.value,
    }));
    setValue(name, e.value);
    clearErrors(name);

    if (name === "shippingMethod") {
      loadShippingMethodRules(e.value, supplyOrders?.supplyOrderItems);
    }
  };

  const handleItemChange = (index: number, key: any, value: any) => {
    const updatedItems = supplyOrders.supplyOrderItems.map(
      (item: any, i: number) => {
        if (i !== index) return item;
        const updated = { ...item, [key]: value };
        if (key === "orderQuantityRequested") {
          updated.totalPrice = Number(
            ((Number(updated.itemPrice) || 0) * (Number(value) || 0)).toFixed(2)
          );
        }
        return updated;
      }
    );

    setSupplyOrders((prevState: any) => ({
      ...prevState,
      supplyOrderItems: updatedItems,
    }));
    setValue(`supplyOrder.${index}.${key}`, value);
    clearErrors(`supplyOrder.${index}.${key}`);
  };

  const onInputChange = (event: any) => {
    const { name, value } = event.target;
    setSupplyOrders({
      ...supplyOrders,
      [name]: value,
    });
    setValue(name, value);
    clearErrors(name);
  };

  const addShippingInfo = () => {
    if (isPaymentRestricted) return;
    if (
      showShippingMethod &&
      hasAnyStripeItem &&
      !supplyOrders?.shippingMethod
    ) {
      toast.error(t("Please select the Shipping Method."));
      return;
    }
    InsuranceService.AddShippingInfo({
      ...supplyOrders,
      status: "Viewed",
      shippingMethod:
        showShippingMethod && hasAnyStripeItem
          ? supplyOrders?.shippingMethod
          : null,
      shippingPrice:
        showShippingPrice && hasAnyStripeItem
          ? supplyOrders?.shippingPrice === "" ||
            supplyOrders?.shippingPrice === null ||
            supplyOrders?.shippingPrice === undefined
            ? null
            : Number(supplyOrders.shippingPrice)
          : null,
    })
      .then((res: any) => {
        if (res?.data?.httpStatusCode === 200) {
          toast.success(res?.data?.message);
          reset();
        } else {
          toast.error(res?.data?.error);
        }
      })
      .catch((err: any) => {
        console.log(err, "err while creating Insurance Provide Assigment");
      });
  };

  const ShipNow = () => {
    const obj = {
      ids: [id],
      courierName: shippingNow.courierName,
      trackingNumber: shippingNow.trackingNumber,
    };

    // If hasPermission is false, run validation
    if (!hasPermission) {
      if (shippingNow.courierName === "" || shippingNow.trackingNumber === "") {
        toast.error(t("Please fill the required details"));
        return; // stop execution
      }
    }

    InsuranceService.saveShippingDetails(obj).then((res: AxiosResponse) => {
      if (res?.data?.httpStatusCode === 200) {
        toast.success(res?.data?.message);
        setShow1(false);
        setShippingNow({ courierName: "", trackingNumber: "" });
        navigate("/manage-order");
      } else {
        toast.error(res?.data?.message);
      }
    });
  };

  const RejectNow = () => {
    const obj = {
      ids: [id],
      rejectedReason: supplyOrders.rejectedReason,
    };
    if (supplyOrders.rejectedReason) {
      InsuranceService.SaveRejectionDetail(obj).then((res: AxiosResponse) => {
        if (res?.data?.httpStatusCode === 200) {
          toast.success(res?.data?.message);
          setShow(false);
          navigate("/manage-order");
        } else {
          toast.error(res?.data?.message);
        }
      });
    } else {
      toast.error("Please fill the required details");
    }
  };

  const loadStatesLookUp = () => {
    InsuranceService.GetStatesLookup()
      .then((res: AxiosResponse) => {
        setDropdownStates(res?.data);
      })
      .catch((err: any) => {
        console.trace(err, "err");
      });
  };

  const ModalhandleClose1 = () => setShow1(false);

  const ModalhandleClose = () => setShow(false);

  useEffect(() => {
    GetShippingInfoById();
    loadFacilitiesLookUp();
    loadStatesLookUp();
  }, []);

  useEffect(() => {
    if (showShippingMethod) {
      loadShippingMethodLookup();
    }
  }, [showShippingMethod]);

  useEffect(() => {
    if (showShippingPrice && shippingMethodRules.length) {
      applyShippingPrice(shippingMethodRules, supplyOrders?.supplyOrderItems);
    }
  }, [supplyOrders?.supplyOrderItems, showShippingPrice]);

  const totalItemsPrice = getTotalItemsPrice(supplyOrders?.supplyOrderItems);
  const shippingCost =
    showShippingPrice &&
    supplyOrders?.shippingPrice !== "" &&
    supplyOrders?.shippingPrice !== null &&
    supplyOrders?.shippingPrice !== undefined
      ? Number(supplyOrders.shippingPrice)
      : 0;
  const grandTotal =
    totalItemsPrice + (Number.isNaN(shippingCost) ? 0 : shippingCost);
  const showOrderSummary =
    (showTotalItemPrice || showShippingPrice) && hasAnyStripeItem;

  const handleOpenModal = () => {
    const aprrovedQuantity = supplyOrders?.supplyOrderItems.filter(
      (item: any) => item.orderQuantityApproved > 0
    );
    if (aprrovedQuantity.length) {
      setShow1(true);
    } else {
      toast.error("Please approve quantity for atleast one record");
    }
  };

  return (
    <>
      <Modal show={show1} onHide={ModalhandleClose1} keyboard={false} size="lg">
        <Modal.Header closeButton className="m-0 p-6">
          <h4>{t("Shipping Detail")}</h4>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-5">
            <p className="text-primary fw-500">
              {t("Specimens selected for shipment")}
            </p>
          </div>
          <div className="border-bottom">
            <ul>
              <li>{supplyOrders?.facilityName}</li>
            </ul>
          </div>
          <div className="mt-5">
            <div className="fv-row mb-4">
              <label className="mb-2 fw-500 required">
                {t("Shipping Courier")}
              </label>
              <Select
                options={shippingCourier}
                theme={(theme: any) => styles(theme)}
                styles={reactSelectStyle}
                menuPortalTarget={document.body}
                placeholder="Shipping Courier"
                name="courierName"
                value={shippingCourier?.filter(
                  (item: any) => item.label === shippingNow.courierName
                )}
                onChange={(event: any) => {
                  handleChangeShipping(event, "courierName");
                }}
              />
            </div>
            <div className="fv-row mb-4">
              <label className="required mb-2 fw-500">{t("Tracking No")}</label>
              <input
                type="text"
                name="trackingNumber"
                onChange={(e) => handleChangeShipping(e)}
                className={`form-control `}
                placeholder="Tracking Number"
                value={shippingNow.trackingNumber}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="py-3 px-6">
          <button
            type="button"
            className="badge badge-pill badge-danger py-3 px-4 border-0 fw-400 fa-1x text-light"
            onClick={() => {
              ModalhandleClose1();
            }}
          >
            {t("Cancel")}
          </button>
          <button
            type="button"
            className="badge badge-pill badge-primary py-3 px-4 border-0 fw-400 fa-1x text-light"
            onClick={ShipNow}
          >
            {t("Ship Now")}
          </button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={show}
        onHide={ModalhandleClose}
        backdrop="static"
        keyboard={false}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton className="m-0 p-6">
          <h4>{t("Rejection Reason")}</h4>
        </Modal.Header>
        <Modal.Body>
          <div className="mt-5">
            <div className="fv-row mb-4">
              <label className="required mb-2 fw-500">
                {t("Rejection Reason")}
              </label>
              <input
                type="text"
                name="rejectedReason"
                onChange={(e) => onInputChange(e)}
                className={`form-control `}
                placeholder="Rejection Reason"
                value={supplyOrders.rejectedReason}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="py-3 px-6">
          <button
            type="button"
            className="badge badge-pill badge-secondary py-3 px-4 border-0 fw-400 fa-1x"
            onClick={() => {
              ModalhandleClose();
            }}
          >
            {t("Cancel")}
          </button>
          <button
            type="button"
            className="badge badge-pill badge-danger py-3 px-4 border-0 fw-400 fa-1x text-light"
            onClick={RejectNow}
          >
            {t("Reject")}
          </button>
        </Modal.Footer>
      </Modal>
      <form
        onSubmit={handleSubmit(addShippingInfo)}
        onKeyDown={handleEnterPress}
      >
        <div id="kt_app_toolbar" className="app-toolbar py-2 pt-lg-3">
          <div
            id="kt_app_toolbar_container"
            className="app-container container-fluid d-flex flex-wrap gap-4 justify-content-center justify-content-sm-between align-items-center"
          >
            <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
              <ul className="breadcrumb breadcrumb-separatorless  fs-7 my-0 pt-1">
                <li className="breadcrumb-item text-muted">
                  <a href="" className="text-muted text-hover-primary">
                    {t("Home")}
                  </a>
                </li>

                <li className="breadcrumb-item">
                  <span className="bullet bg-gray-400 w-5px h-2px"></span>
                </li>

                <li className="breadcrumb-item text-muted">
                  {t("Supply Management")}
                </li>

                <li className="breadcrumb-item">
                  <span className="bullet bg-gray-400 w-5px h-2px"></span>
                </li>

                <li className="breadcrumb-item text-muted">
                  {t("Supply Orders")}
                </li>
              </ul>
            </div>
            <div className="d-flex align-items-center gap-2 gap-lg-3">
              {!buttonsShow || isReadOnly ? null : (
                <PermissionComponent
                  moduleName="Supply Management"
                  pageName="Manage Order"
                  permissionIdentifier="Update"
                >
                  {({ pageName, moduleName, permissionIdentifier }) => (
                    <button
                      className="btn btn-sm fw-bold btn-primary"
                      type="submit"
                    >
                      {getPermissionDisplayName(
                        pageName,
                        moduleName,
                        permissionIdentifier,
                        "Update"
                      )}
                    </button>
                  )}
                </PermissionComponent>
              )}
              {!buttonsShow || isReadOnly ? null : (
                <PermissionComponent
                  moduleName="Supply Management"
                  pageName="Manage Order"
                  permissionIdentifier="OrderViewShip"
                >
                  {({ pageName, moduleName, permissionIdentifier }) => (
                    <button
                      className="btn btn-warning btn-sm fw-bold search d-block fs-12px h-30px py-0 fw-500 text-light"
                      type="button"
                      onClick={() => {
                        if (hasPermission) {
                          ShipNow();
                        } else {
                          handleOpenModal();
                        }
                      }}
                    >
                      {getPermissionDisplayName(
                        pageName,
                        moduleName,
                        permissionIdentifier,
                        "Ship"
                      )}
                    </button>
                  )}
                </PermissionComponent>
              )}
              {!buttonsShow || isReadOnly ? null : (
                <PermissionComponent
                  moduleName="Supply Management"
                  pageName="Manage Order"
                  permissionIdentifier="Reject"
                >
                  {({ pageName, moduleName, permissionIdentifier }) => (
                    <button
                      className="btn btn-sm fw-bold btn-danger"
                      type="button"
                      onClick={() => setShow(true)}
                    >
                      {getPermissionDisplayName(
                        pageName,
                        moduleName,
                        permissionIdentifier,
                        "Reject"
                      )}
                    </button>
                  )}
                </PermissionComponent>
              )}
              <button
                className="btn btn-secondary btn-sm fw-bold "
                aria-controls="SearchCollapse"
                aria-expanded="true"
                type="button"
                onClick={() => reset()}
              >
                <span>
                  <span>{isPaymentRestricted ? t("Back") : t("Cancel")}</span>
                </span>
              </button>
            </div>
          </div>
        </div>
        <div className="app-container container-fluid">
          <div id="ModalCollapse" className="card mb-5">
            <div className="align-items-center card-header d-flex justify-content-center justify-content-sm-between gap-1">
              <h4 className="m-1">{t("Shipping Information")}</h4>
            </div>
            <div id="form-search" className=" card-body">
              <div className="mb-5">
                <span className="text-primary fw-700">{t("Shipping to:")}</span>{" "}
                <span className=" text-primary fw-500">
                  {supplyOrders?.shippingAddress}
                </span>
              </div>
              <div className="row">
                <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                  <div className="fv-row mb-4">
                    <label className="required mb-2 fw-500">
                      {t("Date of Request")}
                    </label>
                    <input
                      {...register("dateofRequest", {
                        required: !isPaymentRestricted,
                      })}
                      type="date"
                      name="dateofRequest"
                      onChange={(e) => onInputChange(e)}
                      className={`form-control `}
                      placeholder="Date of Request"
                      value={moment(
                        formatDate(supplyOrders.dateofRequest),
                        "MM/DD/YYYY"
                      ).format("YYYY-MM-DD")}
                      disabled={isPaymentRestricted}
                    />
                    {errors.dateofRequest && (
                      <p className="text-danger px-2">
                        {t("Please enter the Date of Request.")}
                      </p>
                    )}
                  </div>
                </div>
                <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                  <div className="fv-row mb-4">
                    <label className="required mb-2 fw-500">
                      {t("Representative Name")}
                    </label>
                    <input
                      {...register("representativeName", {
                        required: !isPaymentRestricted,
                      })}
                      type="text"
                      name="representativeName"
                      onChange={(e) => onInputChange(e)}
                      className="form-control bg-transparent"
                      placeholder="Representative Name"
                      value={supplyOrders?.representativeName}
                      disabled={isPaymentRestricted}
                    />
                    {errors.representativeName && (
                      <p className="text-danger px-2">
                        {t("Please enter the Representative Name.")}
                      </p>
                    )}
                  </div>
                </div>
                <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                  <div className="fv-row mb-4">
                    <label className="required mb-2 fw-500">
                      {t("Representative Phone Number")}
                    </label>
                    <InputMask
                      mask="(999) 999 9999"
                      value={supplyOrders?.representativePhone}
                      {...register("representativePhone", {
                        required: isPaymentRestricted
                          ? false
                          : "Phone number is required",
                      })}
                      type="tel"
                      name="representativePhone"
                      onChange={onInputChange}
                      onKeyDown={handleKeyPress}
                      className={`form-control bg-transparent ${
                        errors.representativePhone ? "is-invalid" : ""
                      }`}
                      placeholder="(999) 999 9999"
                      inputMode="numeric"
                      disabled={isPaymentRestricted}
                    />
                    <>{(inputProps: any) => <input {...inputProps} />}</>

                    {errors.representativePhone && (
                      <p className="text-danger px-2">
                        {t("Phone number must be 10 digits.")}
                      </p>
                    )}
                  </div>
                </div>
                <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                  <div className="fv-row mb-4">
                    <label className="required mb-2 fw-500">
                      {t("Shipping Address")}
                    </label>
                    <input
                      {...register("shippingAddress", {
                        required: !isPaymentRestricted,
                      })}
                      type="text"
                      name="shippingAddress"
                      onChange={(e) => onInputChange(e)}
                      className="form-control bg-transparent"
                      placeholder="Shipping Address"
                      value={supplyOrders?.shippingAddress}
                      disabled={isPaymentRestricted}
                    />
                    {errors.shippingAddress && (
                      <p className="text-danger px-2">
                        {t("Please enter the Shipping Address.")}
                      </p>
                    )}
                  </div>
                </div>
                <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                  <div className="fv-row mb-4">
                    <label className="required mb-2 fw-500">{t("City")}</label>
                    <input
                      {...register("city", { required: !isPaymentRestricted })}
                      type="text"
                      name="city"
                      onChange={(e) => onInputChange(e)}
                      className="form-control bg-transparent"
                      placeholder="City"
                      value={supplyOrders?.city}
                      disabled={isPaymentRestricted}
                    />
                    {errors.city && (
                      <p className="text-danger px-2">
                        {t("Please enter city name.")}
                      </p>
                    )}
                  </div>
                </div>
                <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                  <div className="fv-row mb-4">
                    <label className="mb-2 fw-500 required">{t("State")}</label>
                    <Select
                      menuPortalTarget={document.body}
                      {...register("stateId", {
                        required: !isPaymentRestricted,
                      })}
                      options={dropdownStates}
                      theme={(theme: any) => styles(theme)}
                      placeholder="State"
                      name="stateId"
                      value={dropdownStates?.filter(
                        (item: any) => item.value === supplyOrders.stateId
                      )}
                      onChange={(event: any) => {
                        handleChange(event, "stateId");
                      }}
                      isDisabled={isPaymentRestricted}
                    />
                    {errors.stateId && (
                      <p className="text-danger px-2">
                        {t("Please select the State.")}
                      </p>
                    )}
                  </div>
                </div>
                <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                  <div className="fv-row mb-4">
                    <label className="required mb-2 fw-500">
                      {t("Zip Code")}
                    </label>
                    <input
                      {...register("zipCode", {
                        required: !isPaymentRestricted,
                        pattern: isPaymentRestricted
                          ? undefined
                          : {
                              value: /^\d{5}$/,
                              message: "Zip Code must be 5 digits",
                            },
                      })}
                      type="text"
                      name="zipCode"
                      onChange={(e) => onInputChange(e)}
                      onKeyDown={(e) => handleKeyPress(e)}
                      className="form-control bg-transparent"
                      placeholder="Zip Code"
                      value={supplyOrders?.zipCode}
                      maxLength={5}
                      inputMode="numeric"
                      disabled={isPaymentRestricted}
                    />
                    {errors.zipCode && (
                      <p className="text-danger px-2">
                        {t("Zip Code must be 5 digits.")}
                      </p>
                    )}
                  </div>
                </div>
                <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                  <div className="fv-row mb-4">
                    <label className="required mb-2 fw-500">{t("Phone")}</label>
                    <InputMask
                      mask="(999) 999 9999"
                      value={supplyOrders?.phoneNo}
                      {...register("phoneNo", {
                        required: isPaymentRestricted
                          ? false
                          : "Phone number is required",
                      })}
                      type="tel"
                      name="phoneNo"
                      onChange={onInputChange}
                      onKeyDown={handleKeyPress}
                      className={`form-control bg-transparent ${
                        errors.phoneNo ? "is-invalid" : ""
                      }`}
                      placeholder="(999) 999 9999"
                      inputMode="numeric"
                      disabled={isPaymentRestricted}
                    />
                    <>{(inputProps: any) => <input {...inputProps} />}</>

                    {errors.phoneNo && (
                      <p className="text-danger px-2">
                        {t("Phone number must be 10 digits.")}
                      </p>
                    )}
                  </div>
                </div>
                {showShippingMethod && hasAnyStripeItem ? (
                  <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                    <div className="fv-row mb-4">
                      <label className="mb-2 fw-500 required">
                        {t("Shipping")}
                      </label>
                      <Select
                        inputId={`ManageOrderViewOrderShippingMethod`}
                        menuPortalTarget={document.body}
                        {...register("shippingMethod", {
                          required: showShippingMethod && hasAnyStripeItem,
                        })}
                        options={shippingMethodLookup}
                        theme={(theme: any) => styles(theme)}
                        styles={reactSelectStyle}
                        placeholder={t("Select...")}
                        name="shippingMethod"
                        value={shippingMethodLookup.filter(
                          (item) =>
                            String(item.value) ===
                            String(supplyOrders?.shippingMethod)
                        )}
                        onChange={(event: any) => {
                          handleChange(event, "shippingMethod");
                        }}
                        isDisabled={isPaymentRestricted}
                      />
                      {errors.shippingMethod && (
                        <p className="text-danger px-2">
                          {t("Please select the Shipping Method.")}
                        </p>
                      )}
                    </div>
                  </div>
                ) : null}
                {showShippingPrice && hasAnyStripeItem ? (
                  <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                    <div className="fv-row mb-4">
                      <label className="mb-2 fw-500">
                        {t("Shipping Price")}
                      </label>
                      <input
                        id={`ManageOrderViewOrderShippingPrice`}
                        type="text"
                        name="shippingPrice"
                        className="form-control"
                        placeholder={t("Shipping Price")}
                        value={supplyOrders?.shippingPrice ?? ""}
                        disabled
                      />
                    </div>
                  </div>
                ) : null}
                <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                  <div className="fv-row mb-4">
                    <label className="mb-2 fw-500 required">
                      {t("Facility Name")}
                    </label>
                    <Select
                      menuPortalTarget={document.body}
                      {...register("facilityId", {
                        required: !isPaymentRestricted,
                      })}
                      options={dropdown}
                      theme={(theme: any) => styles(theme)}
                      placeholder="Facility Name"
                      name="facilityId"
                      value={dropdown?.filter(
                        (item: any) => item.value === supplyOrders?.facilityId
                      )}
                      onChange={(event: any) => {
                        handleChange(event, "facilityId");
                      }}
                      isDisabled={isPaymentRestricted}
                    />
                    {errors.facilityId && (
                      <p className="text-danger px-2">
                        {t("Please select the facility name.")}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="app-container container-fluid">
          <div className="card mb-5">
            <div className="align-items-center card-header d-flex justify-content-center justify-content-sm-between gap-1">
              <h4 className="m-1">{t("Supplies Information")}</h4>
            </div>
            <div className="card-body py-2 py-md-3">
              <Box sx={{ width: "100%", maxWidth: "100%", overflow: "hidden" }}>
                <div className="table_bordered" style={{ width: "100%" }}>
                  <TableContainer
                    sx={{
                      width: "100%",
                      maxWidth: "100%",
                      maxHeight: "calc(100vh - 100px)",
                      overflowX: "auto",
                      overflowY: "auto",
                      "&::-webkit-scrollbar": {
                        width: 7,
                        height: 7,
                      },
                      "&::-webkit-scrollbar-track": {
                        backgroundColor: "#fff",
                      },
                      "&:hover": {
                        "&::-webkit-scrollbar-thumb": {
                          backgroundColor: "var(--kt-gray-400)",
                          borderRadius: 2,
                        },
                      },
                      "&::-webkit-scrollbar-thumb": {
                        backgroundColor: "var(--kt-gray-400)",
                        borderRadius: 2,
                      },
                    }}
                    className="shadow-none"
                  >
                    <Table
                      aria-label="sticky table collapsible"
                      sx={{ minWidth: 1400 }}
                      className="table table-cutome-expend table-bordered table-sticky-header plate-mapping-table table-bg table-head-custom table-vertical-center border-0 mb-0 "
                    >
                      <TableHead style={{ zIndex: 0 }}>
                        <TableRow className="h-40px">
                          <TableCell
                            sx={{
                              minWidth: 130,
                              whiteSpace: "nowrap",
                            }}
                          >
                            {t("Item Type")}
                          </TableCell>
                          <TableCell
                            sx={{
                              minWidth: 130,
                              whiteSpace: "nowrap",
                            }}
                          >
                            {t("QTY Requested")}
                          </TableCell>
                          <TableCell
                            sx={{
                              minWidth: 130,
                              whiteSpace: "nowrap",
                            }}
                          >
                            {t("QTY Approved")}
                          </TableCell>
                          <TableCell
                            sx={{
                              minWidth: 180,
                              whiteSpace: "nowrap",
                            }}
                          >
                            {t("Item")}
                          </TableCell>
                          <TableCell
                            sx={{
                              minWidth: 180,
                              whiteSpace: "nowrap",
                            }}
                          >
                            {t("Description")}
                          </TableCell>
                          {showTotalItemPrice && hasAnyStripeItem ? (
                            <>
                              <TableCell
                                sx={{
                                  minWidth: 90,
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {t("Price")}
                              </TableCell>
                              <TableCell
                                sx={{
                                  minWidth: 110,
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {t("Total Price")}
                              </TableCell>
                            </>
                          ) : null}
                          <TableCell
                            sx={{
                              minWidth: 160,
                              whiteSpace: "nowrap",
                            }}
                          >
                            {t("Special Request")}
                          </TableCell>
                          {showShippingComments ? (
                            <TableCell
                              sx={{
                                minWidth: 170,
                                whiteSpace: "nowrap",
                              }}
                            >
                              {t("Shipping Comments")}
                            </TableCell>
                          ) : null}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {supplyOrders?.supplyOrderItems?.length ? (
                          supplyOrders?.supplyOrderItems?.map(
                            (item: any, index: number) => (
                              <TableRow key={item.id}>
                                <TableCell>{item?.itemType}</TableCell>
                                <TableCell>
                                  <input
                                    {...register(
                                      `supplyOrder.${index}.orderQuantityRequested`
                                    )}
                                    type="text"
                                    name="orderQuantityRequested"
                                    className="form-control"
                                    placeholder="Order Quantity Requested"
                                    value={item.orderQuantityRequested}
                                    disabled={true}
                                  />
                                </TableCell>
                                <TableCell className="position-relative">
                                  <input
                                    {...register(
                                      `supplyOrder.${index}.orderQuantityApproved`,
                                      { required: !isPaymentRestricted }
                                    )}
                                    onKeyDown={(e) => handleKeyPress(e)}
                                    type="text"
                                    name="orderQuantityApproved"
                                    onChange={(e) =>
                                      handleItemChange(
                                        index,
                                        "orderQuantityApproved",
                                        e.target.value
                                      )
                                    }
                                    className={`form-control ${
                                      (errors as any).supplyOrder?.[index]
                                        ?.orderQuantityApproved
                                        ? "border-danger"
                                        : ""
                                    }`}
                                    placeholder="Order Quantity Approved"
                                    value={item?.orderQuantityApproved}
                                    disabled={isPaymentRestricted}
                                  />
                                </TableCell>
                                <TableCell>{item.itemName}</TableCell>
                                <TableCell>{item.itemDescription}</TableCell>
                                {showTotalItemPrice && hasAnyStripeItem ? (
                                  <>
                                    <TableCell>
                                      {item?.itemPrice !== null
                                        ? item.itemPrice
                                        : ""}
                                    </TableCell>
                                    <TableCell>
                                      {item?.totalPrice !== null
                                        ? item.totalPrice
                                        : ""}
                                    </TableCell>
                                  </>
                                ) : null}
                                <TableCell>
                                  <textarea
                                    className="form-control fw-400 fs-7 p-2 rounded"
                                    name="specialRequest"
                                    placeholder="Special Request"
                                    rows={2}
                                    value={item?.specialRequest}
                                    onChange={(e) =>
                                      handleItemChange(
                                        index,
                                        "specialRequest",
                                        e.target.value
                                      )
                                    }
                                    disabled={isPaymentRestricted}
                                  ></textarea>
                                </TableCell>
                                {showShippingComments ? (
                                  <TableCell>
                                    <textarea
                                      className="form-control fw-400 fs-7 p-2 rounded"
                                      name="shippingComments"
                                      placeholder={t("Shipping Comments")}
                                      rows={2}
                                      value={
                                        item?.shippingComments ??
                                        item?.comments ??
                                        ""
                                      }
                                      onChange={(e) =>
                                        handleItemChange(
                                          index,
                                          "shippingComments",
                                          e.target.value
                                        )
                                      }
                                      disabled={isPaymentRestricted}
                                    ></textarea>
                                  </TableCell>
                                ) : null}
                              </TableRow>
                            )
                          )
                        ) : (
                          <NoRecord />
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              </Box>
            </div>
          </div>
          {showOrderSummary ? (
            <div className="card mb-5">
              <div className="align-items-center card-header minh-42px d-flex justify-content-start justify-content-sm-between gap-1">
                <h4 className="m-1">{t("Order Summary")}</h4>
              </div>
              <div className="card-body py-3">
                <div className="d-flex justify-content-end">
                  <div style={{ minWidth: 280, maxWidth: "100%" }}>
                    {showTotalItemPrice ? (
                      <div className="d-flex justify-content-between align-items-center mb-2 gap-10">
                        <span className="fw-500 text-muted">
                          {t("Total Items Price")}
                        </span>
                        <span className="fw-600">
                          {formatMoney(totalItemsPrice)}
                        </span>
                      </div>
                    ) : null}
                    {showShippingPrice ? (
                      <div className="d-flex justify-content-between align-items-center mb-2 gap-10">
                        <span className="fw-500 text-muted">
                          {t("Shipping Cost")}
                        </span>
                        <span className="fw-600">
                          {formatMoney(shippingCost)}
                        </span>
                      </div>
                    ) : null}
                    <div className="separator my-2"></div>
                    <div className="d-flex justify-content-between align-items-center gap-10">
                      <span className="fw-bold fs-5">{t("Grand Total")}</span>
                      <span className="fw-bold fs-5">
                        {formatMoney(grandTotal)}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </form>
    </>
  );
}
export default ViewOrders;
